import Script from 'next/script';

import { logger } from '#utils/logging/logger';

type EbuOverlayOptions = {
	/**
	 * The identifier of the article the script is included for
	 */
	getArticleID: () => string;

	/**
	 * Callback that returns if the user has given consent that the
	 * EBU integration collects usage metrics.
	 *
	 * @returns `true` if the consent was given `false` otherwise.
	 */
	consentGiven: () => boolean;
};

declare global {
	interface Window {
		NewsOverlay?: (options: EbuOverlayOptions) => void;
	}
}

type Props = { articleId: string };

/**
 * The EBU Overlay component loads the EBU news overlay script. The script will do the following:
 *
 * * It checks if query parameters are set and displays the overlay
 * * It checks for the user consent to track the impressions of the article
 * * It will report tracking metrics on the open overlay if user consent was given
 *
 */
export function EbuOverlay({ articleId }: Props) {
	return (
		<Script
			src="https://br.overlay.yepnews.eu/news-overlay-br.js"
			strategy="afterInteractive"
			onReady={() => {
				try {
					window.NewsOverlay?.({
						getArticleID() {
							return articleId;
						},
						consentGiven() {
							return false;
						},
					});
				} catch (e: any) {
					logger.error(e, 'News overlay client side error');
				}
			}}
		/>
	);
}
